import { RecurringPlanSchema, CustomerRecurringSubscriptionSchema, SubscriptionBillingHistorySchema, } from './base';
// Client-facing schemas - omit internal fields
export const RecurringPlanClientSchema = RecurringPlanSchema.omit({
    businessId: true,
    updatedAt: true,
    deletedAt: true,
});
export const CustomerRecurringSubscriptionClientSchema = CustomerRecurringSubscriptionSchema.omit({
    businessId: true,
    providerSubscriptionId: true,
    updatedAt: true,
    deletedAt: true,
});
export const SubscriptionBillingHistoryClientSchema = SubscriptionBillingHistorySchema.omit({
    businessId: true,
    providerInvoiceId: true,
    updatedAt: true,
    deletedAt: true,
});
